import * as React from "react";
import { forwardRef } from "react";
const TowHitchIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M7.2 6.085a2.55 2.55 0 0 1 2.55 2.55.75.75 0 1 1-1.5 0 1.05 1.05 0 0 0-1.05-1.05.75.75 0 1 1 0-1.5z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7.4 3.985a4.45 4.45 0 0 1 4.45 4.45 4.442 4.442 0 0 1-1.801 3.575v2.425h.384l4.063-6.509.086-.12a1.15 1.15 0 0 1 .89-.421h5.378A1.15 1.15 0 0 1 22 8.536v2.649a1.15 1.15 0 0 1-1.15 1.15h-3.565L13.201 18.8a1.15 1.15 0 0 1-.972.536h-2.18v1.499a1.15 1.15 0 0 1-1.149 1.15h-3a1.15 1.15 0 0 1-1.15-1.15v-1.499H3.198a1.15 1.15 0 0 1-1.15-1.145l-.012-2.802v-.003a.95.95 0 0 1 .95-.95H4.75v-2.425a4.444 4.444 0 0 1-1.8-3.575 4.45 4.45 0 0 1 4.45-4.45zm-1.15 16.5h2.3v-1.149h-2.3v1.149zm5.354-5.091a1.15 1.15 0 0 1-.976.541h-7.09l.009 1.9h8.489l4.083-6.465a1.15 1.15 0 0 1 .973-.535H20.5v-1.95h-4.834l-4.062 6.509zm-3.054-2.66a4.448 4.448 0 0 1-1.149.151 4.46 4.46 0 0 1-1.15-.151v1.701h2.3v-1.701zM7.4 5.485a2.95 2.95 0 1 0 0 5.9 2.95 2.95 0 1 0 0-5.9z"
}));
const ForwardRef = forwardRef(TowHitchIcon);
export default ForwardRef;